module.exports = __webpack_public_path__ + "img/microphone-slash.41e0ea46.svg";